import { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import AdminOnly from '../../components/admin-workspace/AdminOnly';

const Index = lazy(() => import('../../container/instruction/DefaultInstruction'));

function InstructionRoutes() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}`} render={(props) => <AdminOnly><Index {...props} /></AdminOnly>} />
    </Switch>
  );
}

export default InstructionRoutes;
